// @ flow
import React, {useState} from "react";
import {Button, Col, Row, Select} from "antd";
import {PlusOutlined, SafetyOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";

import {pagePermissions, permissionKey} from "../../../../constants/pagePermissions";
import {
    CommunicationPreferencesCardContainer,
    HeaderText
} from "../../../_defaultComponents/CommunicationPreferencesCard/CpStyles";
import {PagePermissionCard} from "./PagePermissionCard";

const belongsToPage = (key, page) => key.startsWith(`${page}.`);

// Acente Temsilcisi'nin sayfa/aksiyon yetkileri. `value` "<sayfa>.<aksiyon>" anahtarlarının
// düz listesidir (backend'de auth.pagePermissions).
export const PagePermissions = ({value = [], onChange}) => {
    const {t} = useTranslation("pagePermissions");
    const [selectedPage, setSelectedPage] = useState();
    const [addedPages, setAddedPages] = useState(() =>
        Object.keys(pagePermissions).filter(page => value.some(key => belongsToPage(key, page)))
    );
    const availablePages = Object.keys(pagePermissions).filter(page => !addedPages.includes(page));

    const changePage = (page, pageKeys) =>
        onChange([...value.filter(key => !belongsToPage(key, page)), ...pageKeys]);

    const addPage = () => {
        setAddedPages(prev => [...prev, selectedPage]);
        // Sayfa eklendiğinde varsayılan olarak yalnızca "Görüntüleme" işaretli gelir; diğer
        // aksiyonlar PagePermissionCard üzerinden ayrıca seçilir (bkz. handleChange orada).
        changePage(selectedPage, [permissionKey(selectedPage, "view")]);
        setSelectedPage(undefined);
    };

    const removePage = page => {
        setAddedPages(prev => prev.filter(addedPage => addedPage !== page));
        changePage(page, []);
    };

    return (
        <CommunicationPreferencesCardContainer
            title={
                <h4>
                    <SafetyOutlined />
                    <HeaderText>{t("pagePermissions.title")}</HeaderText>
                </h4>
            }
        >
            <h5>{t("pagePermissions.page")}</h5>
            <Row gutter={8} style={{marginBottom: 16}}>
                <Col flex="auto">
                    <Select
                        showSearch
                        optionFilterProp="children"
                        style={{width: "100%"}}
                        placeholder={t("pagePermissions.select")}
                        value={selectedPage}
                        onChange={setSelectedPage}
                        data-testid="pagePermissionSelect"
                    >
                        {availablePages.map(page => (
                            <Select.Option key={page} value={page}>
                                {t(`pagePermissions.pages.${page}`)}
                            </Select.Option>
                        ))}
                    </Select>
                </Col>
                <Col>
                    <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        disabled={!selectedPage}
                        onClick={addPage}
                        data-testid="pagePermissionAddButton"
                    >
                        {t("pagePermissions.add")}
                    </Button>
                </Col>
            </Row>
            {addedPages.map(page => (
                <PagePermissionCard
                    key={page}
                    page={page}
                    selectedKeys={value.filter(key => belongsToPage(key, page))}
                    onChange={pageKeys => changePage(page, pageKeys)}
                    onRemove={() => removePage(page)}
                />
            ))}
        </CommunicationPreferencesCardContainer>
    );
};
